export const ARTICLE_HEADER_ALIGNED_CONTAINER_CLASS =
  'mx-auto w-full max-w-[1280px] box-border px-[16px] md:px-[32px] lg:px-[80px] min-[1440px]:box-content'
